const stars = Array.from({ length: 56 }, (_, index) => ({
  id: index,
  left: (index * 37) % 101,
  top: (index * 61) % 97,
  delay: (index % 9) * 0.28,
  size: index % 5 === 0 ? 'star large' : 'star'
}));

export function StarField() {
  return (
    <div className="starfield" aria-hidden="true">
      {stars.map((star) => (
        <span
          className={star.size}
          key={star.id}
          style={{
            left: `${star.left}%`,
            top: `${star.top}%`,
            animationDelay: `${star.delay}s`
          }}
        />
      ))}
    </div>
  );
}
